<template>
  <div class="navbar-bg">
    <div class="navbar">
      <div class="navbar-left">
        <div class="navbar-brand"
             @click="jumpTo('http://www.rayqee.com/index.html')">WoYou工资</div>
        <div class="link"
             @click="jumpTo('http://www.rayqee.com/index.html')">首页</div>
        <div class="link"
             @click="jumpTo('http://www.rayqee.com/index.html#AboutUs')">关于我们</div>
        <div class="link"
             @click="jumpTo('http://www.rayqee.com/index.html#News','_blank')">企业动态</div>
        <div class="link"
             @click="jumpTo('http://www.rayqee.com/index.html#FunctionFeature')">功能亮点</div>
        <div class="link"
             @click="jumpTo('http://www.rayqee.com/index.html#CooperatedPartner')">合作伙伴</div>
        <div class="link"
             @click="jumpTo('http://www.rayqee.com/articleList.html?type=CooperativeNews','_blank')">合作新闻</div>
        <div class="link"
             @click="jumpTo('http://www.rayqee.com/articleList.html?type=MediaNews','_blank')">传媒资讯</div>
        <div class="link"
             @click="jumpTo('http://www.rayqee.com/index.html#JoinUs')">加盟代理</div>
        <div class="link"
             @click="jumpTo('http://www.rayqee.com/creating/index.html')">合作咨询</div>
        <!-- <div class="link"
           @click="$router.push('/contact')">联系我们</div>
           <div class="link"
           @click="$router.push('/success')">精彩案例</div>
      <div class="link"
           @click="$router.push('/apply')">合作申请</div>
      <div class="link"
           @click="$router.push('/contact')">联系我们</div> -->
        <!-- <div class="link"
           @click="
          $router.push({ path: '/loginform', query: { type: 'log' } }),
            $emit('topLogin')
        ">
        帮助
      </div> -->
      </div>
      <div class="navbar-right">
        <div class="loginBtn"
             @click="
          $router.push({ path: '/loginform', query: { type: 'log' } }),
            $emit('topLogin')
        ">
          登录
        </div>
        <div class="loginBtn"
             style="padding-left: 0"
             @click="toReg">注册</div>
        <el-button type="warning"
                   size="medium"
                   @click="
          $router.push({ path: '/loginform', query: { type: 'log' } }),
            $emit('topLogin')
        ">免费使用</el-button>
        <!-- <div>注册</div> -->
      </div>
      <div class="ShowRightFun">
        <a class="eqlee-aside-server"
           title="微信咨询"
           @mouseenter="move('微信咨询')"
           @mouseleave="move('')"><img src="@/assets/img/weixin.png"
               alt="" />
          <div class="serverDetail"
               v-if="flag == '微信咨询'">
            <img style="width: 130px"
                 src="@/assets/img/weixinkefu.png"
                 alt="" />
          </div>

          <p>微信咨询</p>
        </a>
        <a class="eqlee-aside-server"
           title="联系我们"
           href="#"
           @mouseenter="move('联系我们')"
           @mouseleave="move('')">
          <div class="serverDetail"
               v-if="flag == '联系我们'"
               style="text-align: center; padding: 10px">
            手机号码：<span style="
              color: black;
              font-weight: 700;
              display: block;
              padding-top: 10px;
            ">17368262836</span>
          </div>
          <img src="@/assets/img/564e977.png"
               alt="" />
          <p>联系我们</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      flag: "",
    };
  },
  computed: {
    curMenu: function () {
      return window.location.href;
    },
  },
  methods: {
    jumpTo (url, type = '_self') {
      window.open(url, type);

    },
    move (value) {
      // console.log(1);
      this.flag = value;
    },
    open () { },
    toReg () {
      this.$router.push({ path: "/loginform", query: { type: "reg" } });
      this.$emit("TopReg");
    },
  },
};
</script>

<style lang="less" scoped>
a {
  text-decoration: none;
}
.ShowRightFun {
  position: fixed;
  top: 40%;
  right: 2%;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.2);

  z-index: 200;
  .eqlee-aside-server {
    position: relative;
    background: #fff;
    text-align: center;
    color: #999;
    padding: 5px;
    font-size: 14px;
    cursor: pointer;
    transition: transform 0.5s;
    display: block;
    width: 60px;
    min-height: 60px;
    border-bottom: 1px solid #eee;
    .serverDetail {
      background-color: #fff;
      position: absolute;
      top: 0;
      right: 63px;
      height: 60px;
      box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.2);
    }
    img {
      display: table;
      margin: 0 auto 3px;
      width: 63%;
    }
    p {
      margin: 0;

      font-size: 12px;
    }
  }
}
.navbar-bg {
  width: 100%;
  height: 50px;
  background: rgba(0, 0, 0, 0.5);
  border: 0;
  position: fixed;
  top: 0;
  z-index: 10;
}
.navbar {
  max-width: 1311px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  .loginBtn {
    cursor: pointer;
  }
  .navbar-left {
    display: flex;
    align-items: center;
    .link {
      color: #ffffff;
      padding: 0 15px;
      font-size: 16px;
      font-weight: 600;

      cursor: pointer;
    }
  }
  .navbar-brand {
    color: #ffffff;
    font-size: 26px;
    height: 50px;
    padding: 15px 15px;
    font-size: 26px;
    line-height: 20px;
    cursor: pointer;
  }
  .navbar-right {
    color: white;
    display: flex;
    align-items: center;
    div {
      padding: 15px;
    }
  }
}
</style>
